/** Midnight 15 December 2026 in Australia/Melbourne (AEDT, UTC+11). */
export const WEBSITE_BETA_END = '2026-12-14T13:00:00.000Z';
export function isWebsiteBetaOpen(now: number = Date.now()) {
  return (
    process.env.NEXT_PUBLIC_ENABLE_BETA_ENQUIRY !== 'false' &&
    now < Date.parse(WEBSITE_BETA_END)
  );
}
